/**
 * Enum for all config names in ECS
 * Use camel case for names
 */
enum ECSConfigKey {
    RefreshCommandEnabled = "refreshCommandEnabled",
    RequestUnreadCountEnabled = "requestUnreadCountEnabled",
    NewScheduleHeaderEnabled = "newScheduleHeaderEnabled",
    DayNotesInNewScheduleHeaderEnabled = "dayNotesInNewScheduleHeaderEnabled",
    EnableTimeClockDialogs = "enableTimeClockDialogs",
    EnableCopyShiftActivitiesSetting = "enableCopyShiftActivitiesSetting",
    EnableCopyShiftActivitiesFreDialog = "enableCopyShiftActivitiesFreDialog",

    // Enable/disable FRE overhaul changes
    EnableFREMilestone1 = "enableFREMilestone1",

    // Enable/disable support for your multi team my shifts api and Indexed db creation
    EnableMyShiftsApi = "enableMyShiftsApi",

    // Enable/disable support for schedule filter
    EnableScheduleFilter = "enableScheduleFilter",

    // Enable/disable support for Request Swap filtering
    EnableRequestSwapFiltering = "enableRequestSwapFiltering",

    /**
     * DEPRECATED: Use EnableTeamMemberSync instead.
     * Whether fetching team members and users profiles from Graph service is enabled.
     * This includes searching members to add to a schedule group and retrieving user profile info to show in Shifts web schedule and requests tab.
     */
    EnableTeamsAndUsersInfoFromGraph = "enableTeamsAndUsersInfoFromGraph",

    // Enable/disable support for requestable TimeOff reasons.
    EnableTimeOffReasonsFiltering = "enableTimeOffReasonsFiltering",

    EnableCopyDatePickerDialog = "enableCopyDatePickerDialog",
    EnableCopyHeader = "enableCopyHeader",

    // Whether OpenShifts are enabled
    EnableOpenShifts = "enableOpenShifts",

    // Store the sync state in IndexedDb
    EnableSyncStateInIndexedDb = "enableSyncStateInIndexedDb",

    // Store shifts in IndexedDb
    EnableShiftsIndexedDb = "enableShiftsIndexedDb",

    // Union support enabled
    EnableUnionSupport = "enableUnionSupport",

    // Schedule withdraw enabled
    EnableWithdrawSchedule = "enableWithdrawSchedule",

    // Users can request Open Shifts
    EnableOpenShiftRequests = "enableOpenShiftRequests",

    // Scheduled Grid threshold for using a virualized list
    ScheduleGridVirtualizedListThreshold = "scheduleGridVirtualizedListThreshold",

    // Schedule Availability enabled
    EnableScheduleAvailability = "enableScheduleAvailability",

    // Enable print scale to one page
    EnablePrintScaleToOnePage = "enablePrintScaleToOnePage",

    // Enable creating requests
    EnableCreateRequests = "enableCreateRequests",

    // Import schedule polling interval in milliseconds
    ImportSchedulePollIntervalInMilliseconds = "importSchedulePollIntervalInMilliseconds",

    // Import schedule max retry count
    ImportScheduleMaxRetry = "importScheduleMaxRetry",

    // Provision Schedule polling interval in milliseconds
    ProvisionSchedulePollIntervalInMilliseconds = "provisionSchedulePollIntervalInMilliseconds",

    // Provision Schedule max retry count
    ProvisionScheduleMaxRetry = "provisionScheduleMaxRetry",

    // Native Time Clock enabled
    EnableNativeTimeClock = "enableNativeTimeClock",

    // Import excel schedule Page is enabled
    EnableImportExcelSchedulePage = "enableImportExcelSchedulePage",

    // Enable Member Editor Dialog
    EnableMemberEditorDialog = "enableMemberEditorDialog",

    // Enable V2 File Download APIs
    EnableV2FileDownloadAPIs = "enableV2FileDownloadAPIs",

    // Max pages for GDIDR
    GDIDRMaxPages = "gdidrMaxPages",

    // Enable/Disable progressive rendering (rendering scheduler while paging data)
    EnableProgressiveRendering = "enableProgressiveRendering",

    // The number of tags (groups) to download per progressive rendering loop (the first loop will always be 1 for performance)
    ProgressiveRenderingTagsPerLoop = "progressiveRenderingTagsPerLoop",

    // Enable/Disable logging perf data to the console
    EnableConsoleLogPerfData = "enableConsoleLogPerfData",

    // The minimum frequency with which to call the /sync API (fallback in case SignalR is not working)
    MinSyncCallFrequencyMs = "minSyncCallFrequencyMs",

    // The duration that the user has to be inactive for us to assume that they're idle (and the tab is inactive)
    UserIdleStateDurationMs = "userIdleStateDurationMs",

    // The build version to use for the environment+ring+tenant+user combination
    BuildVersion = "buildVersion",

    // How long to wait before we notify the user that there is an updated client build available
    // (this should be at least 5 minutes so that the frontend service has time to refresh its ECS config cache)
    BuildUpdateNotificationDelayMs = "buildUpdateNotificationDelayMs",

    // The min number of members in a team to disable single page print for
    MinTeamSizeToDisableSinglePagePrint = "minTeamSizeToDisableSinglePagePrint",

    // Set the large teams lower limit through ecs, this way we can control large teams limit on run time
    TeamSizeToEnableLargeTeamFeatures = "teamSizeToEnableLargeTeamFeatures",

    // Copy schedule polling interval in milliseconds
    CopySchedulePollIntervalInMilliseconds = "copySchedulePollIntervalInMilliseconds",

    // Copy schedule max retry count
    CopyScheduleMaxRetry = "copyScheduleMaxRetry",

    // Enable V2 Copy Schedule APIs
    EnableCopyScheduleAsyncAPIs = "enableCopyScheduleAsyncAPIs",

    // Enable copy schedule repetition
    EnableCopyScheduleRepetition = "enableCopyScheduleRepetition",

    // Enable Bing Location Detection
    EnableBingLocationDetection = "enableBingLocationDetection",

    // Enable WFI error handling
    EnableWFIErrorHandling = "enableWFIErrorHandling",

    // Enable overall conflict management
    EnableConflictManagement = "enableConflictManagement",

    // Enable conflict management in past shifts/availability
    EnableConflictManagementInPast = "enableConflictManagementInPast",

    // Enable shifts overlap conflict calculation and management
    EnableShiftOverlapConflicts = "enableShiftOverlapConflicts",

    // Enable shifts timeoff conflict calculation and management
    EnableShiftTimeoffConflicts = "enableShiftTimeoffConflicts",

    // Enable conflicts between shift and availability
    EnableShiftAvailabilityConflicts = "enableShiftAvailabilityConflicts",

    // Enable conflicts between shift and request
    EnableShiftRequestConflicts = "enableShiftRequestConflicts",

    // Enable conflicts between request and availability
    EnableRequestAvailabilityConflicts = "enableRequestAvailabilityConflicts",

    // Enable dismassal of conflicts in callout
    EnableConflictsDismissal = "enableConflictsDismissal",

    // Maximum length of a shift (working/absence) that we will calculate conflicts on (shifts longer than this are ignored).
    ConflictCalcMaxShiftLengthInDays = "conflictCalcMaxShiftLengthInDays",

    // Maximum number of conflicts that we'll compute in a view (we'll ignore conflicts past this point)
    ConflictCalcMaxConflictCount = "conflictCalcMaxConflictCount",

    // Enable 24h shift creation and render
    Enable24hShift = "enable24hShift",

    // Enable Copy Schedule By Group
    EnableCopyScheuleByGroups = "enableCopyScheduleByGroups",

    // Enable Copy Schedule By Member
    EnableCopyScheuleByMembers = "enableCopyScheduleByMembers",

    // Enable Time Clock on Web
    EnableTimeClockOnWeb = "enableTimeClockOnWeb",

    // Enable Filter Active Shifts on Schedule
    EnableFilterActiveShifts = "enableFilterActiveShifts",

    // Enable Dialog in Timezone Picker
    EnableDialogTimezonePicker = "enableDialogTimezonePicker",

    // Default Service Endpoint (overrides the value in AppSettings if specified)
    DefaultServiceEndpoint = "defaultServiceEndpoint",

    // Enable using AFD Service URLs
    UseAFDServiceUrl = "useAFDServiceUrl",

    // Enable Export Shifts Match Report
    EnableExportShiftsMatchReport = "enableExportShiftsMatchReport",

    // Enable Conflict Filtering
    EnableConflictFiltering = "enableConflictFiltering",

    // Enable Show Staffhub Teams
    EnableShowStaffhubTeams = "enableShowStaffhubTeams",

    // Enable Shifts targeting helper text
    EnableShiftsTargetingHelperText = "enableShiftsTargetingHelperText",

    // Honor Schedule Owner role in Web
    EnableScheduleOwnerPermission = "enableScheduleOwnerPermission",

    // The max number of items per virtual page to renter in the scheduler (example items: group header row, member row, open shift row)
    // The higher the number, the longer it takes to calculate and render, however there is less "overhead" with managing the pages
    // The lower the number, the faster it calculates and renders each page, however there is more "overhead" for managing each page
    SchedulerItemsPerVirtualPage = "schedulerItemsPerVirtualPage",

    // Export schedule date range limit
    ExportScheduleDateRangeLimit = "exportScheduleDateRangeLimit",

    // Export timeclock entries date range limit
    ExportTimeClocksDateRangeLimit = "exportTimeClocksDateRangeLimit",

    // Connector Dialog
    EnableConnectorAuthenticationFlow = "enableConnectorAuthenticationFlow",

    // Use Compliant Telemetry Client
    EnableEUDBCompliantTelemetryClient = "enableEUDBCompliantTelemetryClient",

    // Current Telemetry region code
    CurrentTelemetryRegionCode = "TelemetryRegion",
    // EU Telemetry Region Code
    EUDBTelemetryRegionCode = "eudbTelemetryRegionCode",

    // Connector authentication Done URL.
    ConnectorAuthenticationDoneURL = "connectorAuthenticationDoneURL",

    // Use the "/api/users/{userId}/dataindaterange" API instead of "/api/tenants/{tenantId}/teams/{teamId}/shifts" API to fetch member shifts for the date picker
    UseUserSpecificApiForShiftHintDatePicker = "useUserSpecificApiForShiftHintDatePicker",

    // Whether the new exceptions properties logging is enabled. When enabled, error message, stack trace and type are logged. This can be disabled if any related Privacy incidents or PII info is logged.
    NewExceptionsPropertiesLoggingEnabled = "NewExceptionsPropertiesLoggingEnabled",

    // Whether the the new in-app feedback experience is enabled.
    NewInAppFeedbackEnabled = "NewInAppFeedbackEnabled",

    /** Whether Cross Location Marketplace is enabled.
    * When enabled, FLMs will be able to create open shifts.
    * These open shifts will be displayed in another tab for FLWs in other schedules to find and apply to.  */
    CrossLocationMarketplaceFeatureEnabled = "CrossLocationMarketplaceFeatureEnabled",

    /** Whether Cross Location Marketplace enhancements are enabled.
    * When enabled, additional features for the Cross Location Marketplace will be available. */
    CrossLocationMarketplaceEnhancementsEnabled = "CrossLocationMarketplaceEnhancementsEnabled",

     /** Whether Op hierarchy check for Cross Location Marketplace is enabled.
    * When enabled, Eligibility check is incorporated inside settings -> open shifts with cross location automatically. */
    CrossLocationOpHierarchyCheckEnabled = "CrossLocationOpHierarchyCheckEnabled",

    /** Whether the option to show archived teams separately is enabled.
     * When enabled, users will be able to view both active and archived teams separately in the All Schedules panel. */
    SeparateArchiveTeamsViewEnabled = "SeparateArchiveTeamsViewEnabled",

    // Whether the button to open smart scheduling is enabled.
    EnableSmartScheduling = "enableSmartScheduling",

    // Whether smart scheduling preview tag is enabled.
    EnableSmartSchedulingPreviewTag = "enableSmartSchedulingPreviewTag",

    /** Whether the option to show new add members view is enabled.
     * When enabled, users will be able to view the new add members view in the `Add members to your group` modal. */
    NewAddMembersViewEnabled = "NewAddMembersViewEnabled",
    // Whether the the console logging is enabled.
    DetailedLoggingEnabled = "DetailedLoggingEnabled",
    // Whether index DB is disabled
    IndexedDbInitializationDisabled = "IndexedDbInitializationDisabled",
    // Whether index DB initialization is parellelized
    ParellelizeIndexedDbInitialization = "ParellelizeIndexedDbInitialization",

    /** Whether Nested App Authentication is enabled.
    * When enabled, access token is fetched using the new NAA approach.
    * When disabled, access token is fetched by using teams-js */
    NaaAuthEnabled = "NaaAuthEnabled",

    DeleteScheduleEnabled = "DeleteScheduleEnabled",

    /** Whether the option to restore a deleted schedule is enabled.
     * When enabled, users will see a Restore button instead of Create for deleted schedules */
    RestoreScheduleEnabled = "RestoreScheduleEnabled",

    /** Client id for app. Dev client id and Prod client id are different. Important to fetch NAA token with corresponding scopes */
    ClientId = "ClientId",

    /** Whether the option to export the legacy Time Clock report is enabled.
     * When enabled, users will be able to export the legacy Time Clock report */
    EnhancedTimeClockReportRadioEnabled = "EnhancedTimeClockReportRadioEnabled",

    /** Whether the option to show the group name to be editable by just clicking on it. When enabled users will be able to rename a group by clicking and editing it without a dialog. */
    RenameGroupEditingEnabled = "RenameGroupEditingEnabled",

    /**Whether the option to show checkbox for a single person request is enabled.
    When enabled, checkbox is not visible when there is only one user in a request, the user is automatically selected,
    and the Action buttons (Approve/Deny) are enabled by default. */
    ToggleCheckboxVisibilityEnabled = "ToggleCheckboxVisibilityEnabled",

    // Whether the options to show users the new add group experience where they are presented with a modal to add a group name and members.
    NewAddGroupExperience = "NewAddGroupExperience",

    /** Whether the option to show the new time off balance setting page is enabled
     * When enabled, users will be able to view the new time off balance setting page */
    TimeOffBalanceEnabled = "TimeOffBalanceEnabled",
    InstrumentScheduleViewStatus = "InstrumentScheduleViewStatus",

    // Whether the option to enable a timeout limit for LoadAppDB
    EnableLoadAppDBTimeout = "EnableLoadAppDBTimeout",
    LoadAppDBDurationMs = "LoadAppDBDurationMs",

    EnableMissingDeviceTicketFix = "EnableMissingDeviceTicketFix",
    /**
     * Whether to use CDL flow for team member sync.
     * This includes fetching team members and user profiles from Teams CDL layer, then fetch from Graph API as fallback.
     * Used when searching for members to add to a schedule group
     */
    EnableTeamMemberSync = "enableTeamMemberSync",

    /**
     * Whether to enable the app refresh on out of sync.
     * When enabled, the app will show a message to the user to refresh the app when it detects that the client is out of sync with the service.
     */
    EnableAppRefreshOnOutOfSync = "enableAppRefreshOnOutOfSync",

    /**
     * When enabled, users will see the MemberEditorContent hosted on NewShiftsDialog instead of ShiftsDialog.
     */
    NewShiftsDialogForMemberEditorContentEnabled = "NewShiftsDialogForMemberEditorContentEnabled",

    /**
     * Enable fix for Accessibility fix for VoiceOver on SlotCount
     */
    AccessibilityFixForSlotCountEnabled = "AccessibilityFixForSlotCountEnabled"
}

export default ECSConfigKey;
